var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15.0 15.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,900 L0,900 L0,0 L1440,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-369.0 -511.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.0 93.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.0 50.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 367.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 2.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,6.09439583 L6.85389796,11.8909387 C5.28597399,13.3696871 2.74386695,13.3696871 1.17594298,11.8909387 C-0.391980993,10.4121903 -0.391980993,8.01466544 1.17594298,6.53591705 L7.32204502,0.739374172 C8.36732767,-0.246458068 10.0620657,-0.246458056 11.1073483,0.739374199 C12.1526309,1.72520645 12.152631,3.32355634 11.1073483,4.30938861 L4.95455849,10.1059315 C4.43191716,10.5988476 3.58454815,10.5988476 3.06190683,10.1059315 C2.5392655,9.61301535 2.5392655,8.8138404 3.06190683,8.32092427 L8.73986181,2.97221006",
    stroke: "#FF5043",
    strokeWidth: 1.28,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.8d3c7c0b135f552f4aa0e47ddccbc403.svg";
export { ForwardRef as ReactComponent };